<template>
    <div class="scroll-down-container">
        <button @click="props.action" class="button cta--scroll-down">{{ label }}</button>
    </div>
</template>

<script setup lang="ts">

    interface Props {
        action: () => void,
        label: string
    }
    const props = defineProps<Props>();

</script>